"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SkipNav_1 = __importDefault(require("./SkipNav"));
exports.default = SkipNav_1.default;
